import { render, staticRenderFns } from "./store-position-add-or-update.vue?vue&type=template&id=d54c446e"
import script from "./store-position-add-or-update.vue?vue&type=script&lang=js"
export * from "./store-position-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports